module.exports = __webpack_public_path__ + "img/img-sign-store.2038d4f5.png";